import React, { useEffect, useState } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { Link } from 'react-router-dom';
import S from '../../pages/ListDam.module.css'
import U from '../../pages/SingleDam.module.css'
import SplitscreenIcon from '@mui/icons-material/Splitscreen';

import {  useDispatch, useSelector } from 'react-redux';
import { useGlobalContext } from '../Context';
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import {   CycloneOutlined, DateRange, Flag, RateReview, SelectAllRounded, Sell, Sensors } from '@mui/icons-material'
import apiService from '../../api/ApiService';
import CattleList from '../cardThemes/cattleList'
import useList from '../CustomHooks/useList';
import { Pagination, Skeleton } from '@mui/material';
import Gadjet from '../../images/gadjet.svg'
import EmptyReturn from '../EmptyReturn';
import { addCattleListComment, changeCommentMode, changePenMode } from '../../redux/slices/listDamSlice';
import { toast } from 'react-toastify';
import AddComment from '../AddCattleComment';
const moment=require('moment-jalaali')


export default function Hoc({flag,id}) {
  const dispatch=useDispatch()
    const {cattleListAddComment,commentMode,penCommentMode}=useSelector(state=>state.list)
    const {isModalCommentOpen,openModallComment}=useGlobalContext();
    const {
        page,handlePage,currentCycle,currentStatus,currentPen,data,pens,statuses,cycleList,setHasSensor,setCurrentCycle,setCurrentPen,setCurrentStatus,hasSensor,currentTheme,total
      } =useList(id)
      const handleSelect = (id) => {
        if (cattleListAddComment.includes(id)) {
          dispatch(addCattleListComment(cattleListAddComment.filter((rowId) => rowId !== id)))
        } else {
          dispatch(addCattleListComment([...cattleListAddComment, id]));
        }
       
      };
      

      
    return (
        <div className={S.AllAnimalssLICon}>
            {flag==='cycle'&&(cycleList.length?<div className='CycleFilterCon'>
            <div onClick={()=>{setCurrentCycle(null)}} className={`CycleFilterITem ${currentCycle===null&&'CycleFilterITemActive'}`}>
          <div>همه</div>

      </div>
  {cycleList.map((item,index)=>{
      return <div onClick={()=>{setCurrentCycle(item?.id||"0")}} className={`CycleFilterITem ${item?.id==currentCycle&&'CycleFilterITemActive'}`}  key={index}>
          <div>{item?.title}</div>
          <div>{item?.count}</div>
      </div>
  })}
  </div>:<div style={{display:'flex',gap:'10px'}}>
  <Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} />
  </div>)}
  {flag==='status'&&(statuses.length?<div className='CycleFilterCon'>
  <div onClick={()=>{setCurrentStatus(null)}} className={`CycleFilterITem ${currentStatus===null&&'CycleFilterITemActive'}`}>
          <div>همه</div>

      </div>
  {statuses.map((item,index)=>{
      return <div onClick={()=>{setCurrentStatus(item?.id||"0")}} className={`CycleFilterITem ${item?.id==currentStatus&&'CycleFilterITemActive'}`}  key={index}>
          <div>{item?.title}</div>
          <div>{item?.count}</div>
      </div>
  })}
  </div>:<div style={{display:'flex',gap:'10px'}}>
  <Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} /><Skeleton animation="wave" height={50} width={80} />
  </div>)}
            <div className='d-flex justify-content-between' >
            <div>
            <select   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`} value={hasSensor} onChange={(e)=>setHasSensor(e.target.value)} >
                
                
                <option  value={null}>همه ی دام ها</option>
                <option  value={true}>دام های با گردنبند</option>
                <option  value={false}>دام های بدون گردنبند</option>
           
        </select>
        {flag!=='pen'&&<select   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`} value={currentPen} onChange={(e)=>setCurrentPen(e.target.value)} >
        <option  value={''}>فیلتر بر اساس بهاربند</option>
                {pens?.length&&pens.map((item,index)=>{
                             return <option key={index}  value={item?.id}>{item?.name}</option>
    
                })}
         
           
        </select>}
        {flag!=='status'&&<select   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`} value={currentStatus} onChange={(e)=>setCurrentStatus(e.target.value)} >
        <option  value={''}>فیلتر بر اساس وضعیت</option>
                {statuses?.length&&statuses.map((item,index)=>{
                             return <option key={index}  value={item?.id}>{item?.title} {item?.count}</option>
    
                })}
         
           
        </select>}
        {flag!=='cycle'&&<select   id='sele'  name='sele' className={`selectInp ${S.selectStyle}`} value={currentCycle?.id} onChange={(e)=>setCurrentCycle(e.target.value)} >
        <option  value={''}>فیلتر بر اساس چرخه </option>
                {cycleList?.length&&cycleList.map((item,index)=>{
                             return <option key={index}  value={item?.id}>{item?.title} {item?.count}</option>
    
                })}
         
           
        </select>}
            </div>
            <div style={{padding:'0px'}} data-title='افزودن یادداشت' onClick={()=>{
              dispatch(changeCommentMode(commentMode));dispatch(changePenMode(true));!commentMode&&toast('دام یا دام هایی را انتخاب کنید')
            }} className={U.EditBtnTableDam}>
                <RateReview sx={{fontSize: { xs: 26, sm: 30, md: 30, lg:30} }}/>
            </div>
            </div>
            {!currentTheme&&<div className={S.TabForAllAnnimLICon} style={{zIndex:22}}>
              
              
              <div className={S.AnimContentLI} data-aos='fade'>
              {data?.length?<table>
                  <thead>
                  <tr>
                    {commentMode&&<th>
                      <div className='LogoFormT'><div><span>
                    <SelectAllRounded/>
                    </span>
                        </div></div>
                      </th>}
                    <th>
                      <div className='LogoFormT'><div><span>
                    <SplitscreenIcon/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <ReportIcon/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <CycloneOutlined/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <Sensors/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <Sell/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <Sell/>
                    </span>
                        </div></div> 
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <img width={25} height={25} src={Gadjet}/>
                    </span>
                        </div></div> 
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <FemaleIcon/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <DateRange/>
                    </span>
                        </div></div>
                      </th>
                      <th>
                      <div className='LogoFormT'><div><span>
                    <InfoIcon/>
                    </span>
                        </div></div>
                      </th>
                      
                      
                    </tr>
                    <tr>
                      {commentMode&&cattleListAddComment.length?<th  >
                      <div onClick={openModallComment} className="btnConfirmComment">تایید</div> 
                      </th>:commentMode&&<th>
                        انتخاب
                      </th>}
                      <th>
                        ردیف
                      </th>
                      <th>
                        وضعیت
                      </th>
                      <th>
                       چرخه دام
                      </th>
                      <th>
                        سنسور
                      </th>
                      <th>
                        شماره گوش
                      </th>
                      <th>
                        شماره بدن
                      </th>
                      <th>
                        شماره گردنبند
                      </th>
                      <th>
                        جنسیت
                      </th>
                      <th>
                        تاریخ تولد
                      </th>
                      
                      <th>
                        جزئیات
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      data?.length&&data?.map((item,index)=>{
                        const {birthdate}=item;
                        const birth=birthdate?.substring(0,10);
                        const pbirth=moment(birth).format('jYYYY-jMM-jDD')
                        return <tr key={index}>
                          {commentMode&&<td>
                          <input  checked={cattleListAddComment.includes(item.id)} onChange={()=>{
                            handleSelect(item.id)
                          }}  type='checkbox'/>
                        </td>}
                        <td>
                          {(index+1)+(page==0?0:page-1)*8}
                        </td>
                        <td>
                          {item.cattleStatusTitle}
                        </td>
                        <td>
                          {item.cattleLifeCycleTitle}
                        </td>
                        <td>
                          {item.sensor?.deviceCode}
                        </td>
                        <td>
                          {item.earTagNumber}
                        </td>
                        <td>
                          {item.bodyNumber}
      
                        </td>
                        <td>
                          {item.sensor?.necklaceNumber}
      
                        </td>
                        <td>
                          {item.gender===2?'ماده':'نر'}
                        </td>
                        <td>
                          {pbirth}
                        </td>
                       
                        <td className={S.DetIc}>
                          <Link to={`${item.id}`}>
                           <div className='btnCardDAm'> مشاهده</div>
                          </Link>
                        </td>
                      </tr>
                      
                      })
                    }
                    
                    
                    
                    
                    
    
                  </tbody>
                </table>:<EmptyReturn/>}
              </div>
            </div>}
            {
            currentTheme&&<CattleList data={data}/>
            }
            <div className='PaginateContainer'>
            <Pagination   defaultPage={1} count={total} page={page==0?page+1:page} onChange={handlePage} variant="outlined" color="primary"  boundaryCount={2}/>
            </div>
            {isModalCommentOpen&&<AddComment flag='cattles'/>}
        </div>
      );
  
}